import type { HbmlElementNode } from "@holibob-packages/hbml";

import { HbmlRendererNodes } from "../HbmlRenderer";
import { TypographyDocument } from "../TypographyDocument";

export function HbmlNumberedListNode({ content }: { content: HbmlElementNode }) {
    return (
        <TypographyDocument variant="ol">
            <HbmlRendererNodes content={content.children} />
        </TypographyDocument>
    );
}
